<template>
  <div class="company-user-item-role-bd">
    <div class="add-user-role">
      <div class="title">
        <h1>{{ $t('company_user_item_role.qsyygyxgw') }}</h1>
        <p>{{ $t('company_user_item_role.ygjyybsygwdtdgnqx') }}</p>
      </div>
      <div class="role-list">
        <ul class="ubw">
          <li class="ub ub-sp" :class="{ cur: item.selected }" v-for="item in roleList" :key="item.roleId">
            <el-checkbox v-model="item.selected">{{ item.roleName }}</el-checkbox>
            <i class="icon icon-shiliang" @click="openRolePer(item)" v-if="funcView.role_list_user" :class="{ 'item-disabled': item.roleType == 5 }"></i>
          </li>
          <li class="add-role" @click="addRole">
            <i class="icon icon-tianjia"></i>
            <span>{{ $t('company_user_item_role.xin_zeng_gang_wei') }}</span>
          </li>
        </ul>
      </div>
      <div class="title" style="margin-top: 8px">
        <h1>{{ $t('company_user_item_role.ygxyjssmlxdxx') }}</h1>
        <p>{{ $t('company_user_item_role.qxzygxyjsdxxlx') }}</p>
      </div>
      <div class="sms-list">
        <ul class="ubw">
          <li v-for="item in msgRoleList" :key="item.roleId">
            <el-checkbox v-model="item.selected">{{ item.roleName }}</el-checkbox>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer ub ub-xc ub-ae">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" v-if="type === 'add'" @click="onBack()">{{ $t('company_user_item_role.shang_yi_bu') }}</el-button>
      <el-button type="warning" v-if="type === 'add'"  @click="saveRoleUser">{{ $t('Common.com_finish') }}</el-button>
      <el-button type="warning" v-if="type == 'edit'" @click="saveRoleUser">{{ $t('Common.com_save') }}</el-button>
    </div>
    <role-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="successAddRole"></role-dialog>
    <custom-dialog appendToBody width="72%" :title="$t('company_user_item_role.jue_se_quan_xian')" :visible="dialogVisible2" @close="dialogVisible2 = false">
      <div style="padding: 0 24px">
        <role-permission ref="rolePermission" style="height: 700px" type="dialog" :roleId="roleId" @success="dialogVisible2 = false" :disabled="roleDisabled"></role-permission>
      </div>
      <div slot="footer" class="dialog-footer" v-if="roleDisabled">
        <el-button type="warning" @click="dialogVisible2 = false">{{ $t('Common.com_confirm') }}</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-else>
        <el-button @click="dialogVisible2 = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="warning" @click="saveRolePer">{{ $t('Common.com_save') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

import roleDialog from './role_dialog.vue';
import rolePermission from './role_permission.vue';

export default {
  props: {
    type: String,
    userId: [String, Number],
  },
  components: { roleDialog, rolePermission },
  data() {
    return {
      roleId: '',
      roleDisabled: false,
      msgRoleType: '',
      msgServiceType: '',
      roleList: [],
      msgServiceList: [],
      msgRoleList: [],
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
    };
  },
  mounted: function () {
    this.getDictionary('bas_role_type', (data) => {
      const msgRoleType = data.bas_role_type.find(t => t.code === 'notice_role') || {};
      const msgServiceType = data.bas_role_type.find(t => t.code === 'service_role') || {};
      this.msgRoleType = msgRoleType.value || '';
      this.msgServiceType = msgServiceType.value || '';
      this.getRoleList();
    });
    this.getFuncView();
  },
  methods: {
    onCancel: function () {
      this.$emit('cancel');
    },
    onBack: function () {
      this.$emit('back');
    },
    // 获取岗位列表
    getRoleList: function () {
      this.$getJSON(apis.UserRoleAll, { isShowNotice: 1, isShowService: 1 }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.selected = false;
        });
        // 服务类型
        this.msgServiceList = list.filter(t => `${t.roleType}` === `${this.msgServiceType}` && t.state === 1);
        // 消息类型
        this.msgRoleList = list.filter(t => `${t.roleType}` === `${this.msgRoleType}` && t.state === 1);
        // 自定义
        const roleList = list.filter(t => `${t.roleType}` !== `${this.msgRoleType}` && t.state === 1 && `${t.roleType}` !== `${this.msgServiceType}` && t.state === 1);
        this.roleList = [...this.msgServiceList, ...roleList];
        this.getUserRoleList();
      });
    },
    // 获取用户关联的岗位
    getUserRoleList: function () {
      if (!this.userId) {
        return;
      }
      this.$getJSON(apis.UserRole, { bizId: this.userId }).then((res) => {
        const userRoleIds = res.data.map(t => t.roleId);
        this.roleList.forEach((item) => {
          item.selected = userRoleIds.includes(item.roleId);
        });
        this.msgRoleList.forEach((item) => {
          item.selected = userRoleIds.includes(item.roleId);
        });
      });
    },
    // 新增岗位
    addRole: function () {
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('company_user_item_role.xin_zeng_gang_wei');
      this.dialogVisible1 = true;
    },
    // 新增岗位成功
    successAddRole: function () {
      this.getRoleList();
    },
    // 用户批量关联岗位
    saveRoleUser: function () {
      const roleIds = [...this.roleList, ...this.msgRoleList].filter(t => t.selected).map(f => f.roleId);
      if (!roleIds.length) {
        this.$message.error(this.$t('company_user_item_role.qxzzsyggwhxxlx'));
        return;
      }
      this.$postJSON(apis.UserRoleAdd, {
        bizId: this.userId,
        bizName: this.userName,
        bizType: 3,
        roleIds: roleIds,
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.$emit('cancel');
      });
    },
    // 配置岗位权限
    openRolePer: function (item) {
      this.roleId = item.roleId;
      this.roleDisabled = `${item.roleType}` === '5';
      this.dialogVisible2 = true;
    },
    // 保存岗位权限
    saveRolePer() {
      this.$refs.rolePermission.saveRolePer();
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.company-user-item-role-bd {
  .item-disabled {
    opacity: 0.2;
  }
  .add-user-role {
    padding: 24px 24px 12px;
    .title {
      h1 {
        color: $--color-text-primary;
        font-size: 18px;
        line-height: 40px;
        font-weight: bold;
      }
      p {
        color: #818181;
        font-size: 14px;
        margin-top: 8px;
        margin-bottom: 16px;
        line-height: 20px;
      }
    }
    ul li {
      width: 250px;
      height: 40px;
      font-size: 14px;
      line-height: 40px;
      background-color: #f8f9fa;
      border-radius: 8px;
      margin-right: 16px;
      margin-bottom: 16px;
      padding: 0 12px;
      &.cur {
        background: rgba(0, 160, 217, 0.08);
      }
      .icon {
        font-size: 14px;
        cursor: pointer;
        color: $--color-text-secondary;
      }
      .el-checkbox__label {
        font-size: 14px;
        color: $--color-text-secondary;
        font-weight: normal;
      }
      .is-checked {
        .el-checkbox__label {
          color: $--color-text-secondary;
          font-weight: bold;
        }
      }
      &.add-role {
        cursor: pointer;
        background: none;
        text-align: center;
        line-height: 38px;
        color: $--color-primary;
        border: 1px $--color-primary dashed;
        i.icon {
          color: $--color-primary;
          margin-right: 6px;
          font-size: 14px;
        }
      }
    }
  }
  .footer {
    height: 88px;
    padding: 0 24px;
    background: #f8f9fa;
  }
}
</style>
